export enum Units {
  PIECE = 1,
  TONNE = 101,
  KILOGRAM = 102,
  CUBIC_METER = 201,
  LITER = 202,
  METER = 301,
  HOUR = 401,
  DAY = 402,
  SQUARE_METER = 501
}
